import { connect } from 'react-redux';
import { fetchJobStatus } from 'src/reducers/JobStatus';
import DownloadBonusReports from 'src/features/EmployeeBonus/components/DownloadBonusReports';
import { setLoaded } from 'src/reducers/employees/employeeBonus';

function mapStateToProps(state) {
  return {
    jobStatus: state.JobStatus.report_employee_bonus_job,
    bonusPage: state.employeeBonus.bonusPage
  };
}

// 本対応はこのissueで行う
// 本対応後はsetLoadedは削除
// https://github.com/d-o-n-u-t-s/payrollservice/issues/6034

function mapDispatchToProps(dispatch) {
  return {
    fetchClientBonusReportCreationStatus: clientBonusId => {
      const params = {
        job_name: 'report_employee_bonus_job',
        search_params: { client_bonus_id: clientBonusId }
      };
      dispatch(fetchJobStatus(params));
    },
    setLoaded: () => {
      dispatch(setLoaded({ isLoaded: true }));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadBonusReports);
